import { PeopleRole } from "../models/peopleCandidate";
import axiosConfig from "./axiosConfig";

export interface PullContactInfoResponse {
  status: "pending";
  operationKey: string;
  siteId: string;
  // True when an identical pull was already in flight for this (lead, role) and we
  // coalesced onto it rather than spawning a second one.
  deduped?: boolean;
}

// Kick off step-7 contact enrichment (Apollo People Match) for the operator's
// selected people in a role, as a long-running operation. `apolloIds` are the
// ticked people from the ranked OR the AI-excluded list. Returns {operationKey,
// siteId} immediately; the worker reveals each person's email + LinkedIn + title,
// skipping any id already pulled (no re-charge), and writes the results onto the
// lead's contactEnrichments[role]. The FE polls useOperation(...) until terminal,
// then refetches the lead to show the pulled contacts.
const postLeadPullContactInfo = async (
  authToken: string,
  leadId: string,
  role: PeopleRole,
  apolloIds: string[]
): Promise<PullContactInfoResponse> => {
  const { data } = await axiosConfig.post(
    `/leads/${leadId}/pull-contact-info`,
    { role, apolloIds },
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default postLeadPullContactInfo;
